import * as React from "react"
import { AuthContextSetState } from "components/auth-provider/AuthProvider"

function useAuth() {
	const dispatch = React.useContext(AuthContextSetState)

	function login(token: string) {
		dispatch(token)
	}

	function logout() {
		dispatch("")
	}

	return { login, logout }
}

export default useAuth
